import React from 'react';
import {
  AppLayout,
  FiltersContainer,
} from 'sections/services-marketplace/experts/components';
import {
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
  Card,
} from '@shopify/polaris';

import styles from './ServiceListings.scss';

export function SkeletonServiceListings() {
  return (
    <div className={styles.ServiceListingsContainer}>
      <AppLayout.Container>
        <AppLayout.Section size="OneFifth">
          <FiltersContainer>
            <TextContainer>
              {[...Array(4).keys()].map(key => (
                <SkeletonDisplayText size="small" key={key} />
              ))}
            </TextContainer>
          </FiltersContainer>
        </AppLayout.Section>
        <AppLayout.Section fill>
          <div className={styles.Grid}>
            {[...Array(6).keys()].map(key => (
              <div key={key}>
                <Card sectioned>
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={3} />
                  </TextContainer>
                </Card>
              </div>
            ))}
          </div>
        </AppLayout.Section>
      </AppLayout.Container>
    </div>
  );
}
